const bg='#ffffffff';
export const BUTTON_STYLE_MAP = {
  search: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '50px',
  },
  clear: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '50px',
  },
  export: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '50px',
  },
  columns: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '135px',
  },
  fullscreen: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '128px',
  },
  normal: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '135px',
  },
  compact: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '135px',
  },
  next: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '20px',
  },
  previous: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '15px',
  },
    refresh: {
    bg: bg,
    color: '#111827',
    border: '1px solid #d1d5db',
    activeBg: '#2563eb',
    activeColor: '#fff',
    minWidth: '50px',
  },
};
